export default "__VITE_ASSET__b0d2d3a7__"